module.exports = " <div class=text> <textarea></textarea> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text.vue
// module id = 741
// module chunks = 2